import { useState } from 'react';
import Image from 'next/image';
import s from './StructureImages.module.scss';

export const StructureImages = ({ images }: { images: string[] }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  if (images.length === 0) return null;

  return images.length === 1 ? (
    <div className={s.oneImage}>
      <Image
        src={images[activeImageIndex]}
        alt={'Основное изображение'}
        sizes={'(max-width: 1000px) 936px, 936px'}
        height={0}
        width={0}
      />
    </div>
  ) : (
    <div className={s.grid}>
      <ul className={s.grid__list}>
        {images.map((image, i) => {
          return (
            <li
              key={i}
              className={s.grid__item}
              onClick={() => setActiveImageIndex(i)}
            >
              <Image
                src={image}
                alt={'Изображение в галерее'}
                sizes={'(max-width: 720px) 108px, (max-width: 1256px) 150px, 306px'}
                // width={306}
                // height={170}
                fill
              />
            </li>
          );
        })}
      </ul>
      <div className={s.grid__main}>
        <Image
          src={images[activeImageIndex]}
          alt={'Увеличенное изображение в галерее'}
          // sizes={'(max-width: 1000px) 602px, 602px'}
          width={621}
          height={526}
        />
      </div>
    </div>
  );
};